import React from 'react';

export const useScrollTo = <THTMLElement extends HTMLElement>(
  formReference?: React.RefObject<THTMLElement>
): {
  goToField: (fieldId: string) => void;
  scrollToTargetAdjusted: (element: Element) => void;
  findInput: (fieldId: string) => Element | null | undefined;
} => {
  const findInput = (fieldId: string): Element | null | undefined => {
    return (formReference?.current ?? document).querySelector(
      `[id=${fieldId}] input, [id=${fieldId}] textarea, [id=${fieldId}] select`
    );
  };

  const getScrollParent = (node: HTMLElement): null | HTMLElement => {
    if (node == null) {
      return null;
    }

    if (node.scrollHeight > node.clientHeight) {
      return node;
    } else {
      return getScrollParent(node.parentNode as HTMLElement);
    }
  };

  const scrollToTargetAdjusted = (element: Element): void => {
    const headerOffset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition - headerOffset;

    const scrollableParent = formReference?.current
      ? getScrollParent(formReference.current as HTMLElement)
      : null;

    (scrollableParent ?? window).scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  const goToField = (fieldId: string): void => {
    const input = findInput(fieldId);
    // scroll to element and focus
    if (input) {
      const inputElem = input as HTMLInputElement;
      scrollToTargetAdjusted(inputElem);

      setTimeout(() => {
        inputElem.focus();
      }, 100);
    }
  };

  return {
    goToField,
    scrollToTargetAdjusted,
    findInput
  };
};
